// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sGORX","right":"styles_right__2Ytjl"};